import http from '../../../shared/utils/HttpClient';
import { ThemePageType } from '../types';

const get = async (employerCode: string | null, theme: string, language: string): Promise<ThemePageType> => {
  let url = `Themes?theme=${theme}&language=${language}`;
  if (employerCode !== null && employerCode !== 'null') {
    url += `&orgUnitCode=${employerCode}`;
  }

  const { data } = await http.get(url);
  return data;
};

export default get;
